import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getInvoiceList = createAsyncThunk(
    'invoice/getInvoiceList',
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/invoices/list`,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            if (response.data.status) {
                return response.data.response
            }
        } catch (error) {

        }

    }
);

export const Invoices = createAsyncThunk(
    'invoice/Invoices',
    async ({ token, frequency, amount, subscriptionStart, subscriptionEnd }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/invoices`,
                {
                    frequency,
                    price: parseInt(amount),
                    currency: "INR",
                    subscriptionStart,
                    subscriptionEnd,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            if (response.data.status) {
                return response.data
            }
        } catch (error) {

        }

    }
);

const invoiceSlice = createSlice({
    name: 'invoice',
    initialState: {
        invoices: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(Invoices.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(Invoices.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(Invoices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getInvoiceList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getInvoiceList.fulfilled, (state, action) => {
                state.loading = false;
                state.invoices = action.payload || [];


            })
            .addCase(getInvoiceList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default invoiceSlice.reducer;